import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { TeamCardList } from "../TeamCardList";
import { TeamTileList } from "../TeamTileList";
import { useAboutUsPage } from "../hooks";
import { AboutUsAdvisor, AboutUsTeamMember } from "../types";
import { Typography } from "@parkschannel/ui";
import { AdvisorModal, AdvisorModalProvider } from "../AdvisorModal";
export const WhoWeAreSection = ()=>{
    const { useAboutUsPageQuery  } = useAboutUsPage();
    const { data: aboutUs  } = useAboutUsPageQuery();
    const members = useMemo(()=>{
        var ref;
        return ((aboutUs === null || aboutUs === void 0 ? void 0 : (ref = aboutUs.data) === null || ref === void 0 ? void 0 : ref.team) || []).map((member)=>AboutUsTeamMember.fromAboutUsResponse(member));
    }, [
        aboutUs
    ]);
    const advisors = useMemo(()=>{
        var ref;
        return ((aboutUs === null || aboutUs === void 0 ? void 0 : (ref = aboutUs.data) === null || ref === void 0 ? void 0 : ref.advisors) || []).map((advisor)=>AboutUsAdvisor.fromAboutUsResponse(advisor));
    }, [
        aboutUs
    ]);
    if (!aboutUs) return null;
    return /*#__PURE__*/ _jsxs("section", {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "h2",
                className: "text-neutral-800 mb-6 lg:mb-8",
                children: "Who we are"
            }),
            /*#__PURE__*/ _jsx(TeamCardList, {
                members: members
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "pt-10 lg:pt-[56px]",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        component: "h3",
                        variant: "h4",
                        className: "text-neutral-900 mb-6 lg:mb-8",
                        children: "Board of Advisors"
                    }),
                    /*#__PURE__*/ _jsxs(AdvisorModalProvider, {
                        children: [
                            /*#__PURE__*/ _jsx(TeamTileList, {
                                members: advisors
                            }),
                            /*#__PURE__*/ _jsx(AdvisorModal, {})
                        ]
                    })
                ]
            })
        ]
    });
};
